module.exports = __webpack_public_path__ + "static/media/me.e749b2e0.png";